import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConsultaVisitaComponent } from './consulta-visita.component';

const routes: Routes = [
  { path: '', component: ConsultaVisitaComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConsultaVisitaRoutingModule { }
